module.exports = __webpack_public_path__ + "img/rocket-01.d7462d96.svg";